import { useState } from "react";
import styled, { keyframes } from "styled-components";
import { media } from "../lib/styles/media";

const fadeIn = keyframes`
  from { opacity: 0; transform: translate(-50%, -48%); }
  to   { opacity: 1; transform: translate(-50%, -50%); }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
`;

const Modal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
  background: #1a1a1a;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 16px;
  padding: 40px 0px;
  width: 480px;
  max-width: 90vw;
  text-align: center;
  animation: ${fadeIn} 0.3s ease;

  ${media.phone`
    padding: 32px 24px;
  `}
`;

const Emoji = styled.div`
  font-size: 2.4rem;
  margin-bottom: 16px;
`;

const Title = styled.h2`
  color: #ffffff;
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 12px;
  line-height: 1.4;
`;

const Description = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
  line-height: 1.6;
  margin: 0 0 28px;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;

  ${media.phone`
    flex-direction: column;
  `}
`;

const GoButton = styled.a`
  display: inline-block;
  padding: 12px 28px;
  background: #ffffff;
  color: #111111;
  font-weight: 700;
  font-size: 0.9rem;
  border-radius: 8px;
  text-decoration: none;
  transition: background 0.2s;

  &:hover {
    background: #e0e0e0;
  }
`;

const CloseButton = styled.button`
  padding: 12px 28px;
  background: transparent;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.9rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  cursor: pointer;
  transition:
    border-color 0.2s,
    color 0.2s;

  &:hover {
    border-color: rgba(255, 255, 255, 0.5);
    color: rgba(255, 255, 255, 0.8);
  }
`;

export default function NewSitePopup() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <>
      <Overlay onClick={() => setVisible(false)} />
      <Modal>
        <Emoji>🎉</Emoji>
        <Title>새로운 포트폴리오 사이트가 오픈했습니다!</Title>
        <Description>
          새로워진 UI/UX를 새 사이트에서 만나보세요.
          <br />새 사이트에서 만나요!
        </Description>
        <ButtonRow>
          <GoButton
            href="https://leewonno.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            새 사이트로 이동
          </GoButton>
          <CloseButton onClick={() => setVisible(false)}>
            여기 둘러보기
          </CloseButton>
        </ButtonRow>
      </Modal>
    </>
  );
}
